import { useCallback, useMemo } from 'react'
import { useSelector } from 'react-redux'
import { useHistory, useParams } from 'react-router-dom'

import { useRejectPkgReq } from '../../../api/package-req'
import DataGrid from '../../../Components/DataGrid/DataGrid'
import { usePackageReqColDefs } from './usePackageReqColDefs'

export const PackageRequestDataGrid = ({ data, isLoading }) => {
  const history = useHistory()
  const { mutateAsync: rejectPackageReqMutation } = useRejectPkgReq()
  const params = useParams()

  const reqType = useMemo(() => {
    switch (params.reqType) {
      case 'uniteRequest':
      case 'photoRequest':
      case 'shrinkRequest':
      case 'returnRequest':
        return params.reqType
      default:
        return 'all'
    }
  }, [params.reqType])

  const title = useMemo(() => {
    switch (reqType) {
      case 'uniteRequest':
        return 'Unite Requests'
      case 'photoRequest':
        return 'Photo Requests'
      case 'shrinkRequest':
        return 'Shrink Requests'
      case 'returnRequest':
        return 'Return Requests'
      default:
        return 'All Requests'
    }
  }, [reqType])
  const filteredData = useMemo(() => {
    if (!data) return []
    if (reqType === 'all') {
      return Object.values(data).flat()
    }
    return data[reqType]
  }, [data, reqType])

  const { loggedUser } = useSelector(state => state.user)

  const canDeleteUniteReq =
    loggedUser.permissions['Admin'] ||
    loggedUser.permissions['Senior Agent'] ||
    loggedUser.permissions['Agent'] ||
    loggedUser.permissions['Office Manager']

  const onRemoveClick = useCallback(
    async req => {
      const isConfirmed = window.confirm('Are you sure you want to delete this unite request?')
      if (!isConfirmed) return
      await rejectPackageReqMutation({ packageReqId: req.id, rejectReason: 'canceled' })
    },
    [rejectPackageReqMutation]
  )
  const onSetPackageReqChosen = useCallback(
    req => {
      history.push(`/office-packageRequests/${req.reqType}/${req.id}`)
    },
    [history]
  )
  const columnDefs = usePackageReqColDefs({
    canRemove: canDeleteUniteReq,
    reqType,
    onRemoveClick,
    onSetPackageReqChosen,
  })
  return (
    <div className='package-reqs-page-cont'>
      <h2>{title}</h2>
      <DataGrid entityName={reqType} rowData={filteredData} columnDefs={columnDefs} loading={isLoading} />
    </div>
  )
}
